module.exports = __webpack_public_path__ + "media/images/icons/outlined/alipay-97fe27d14bb7df833694ea3e87655ffd.svg";